import UserActivity from './useractivity';

let PageIcon = {
	icon_timer: null,
	icon_defimg: '/assets/i/favicon.ico',
	icon_msgimg: '/assets/i/favicon_bg.ico',

	init(){
		UserActivity.onUserActivityChanged.on((active) => {
			if (active){
				this.stopRolling();
			}
		});
	},

	setIcon(ref){
		document.querySelector('link[rel~=icon]').href = ref;
	},

	rollIcon(){
		let icon = document.querySelector('link[rel~=icon]');
		this.setIcon(icon.href.includes(this.icon_defimg) ? this.icon_msgimg : this.icon_defimg);
	},

	startRolling(){
		if (!this.icon_timer){
			this.icon_timer = setInterval(this.rollIcon.bind(this), 800);
		}
	},

	stopRolling(){
		if (this.icon_timer){
			clearInterval(this.icon_timer);
			this.icon_timer = null;
			this.setIcon(this.icon_defimg);
		}
	},
};

export default PageIcon;
